const regex = {
  EmailFormatoIncorreto: /@/,
  EmailIncompleto: /@.+/,
  EmailPosicaoIncorreta: /@.+\..+/,
};

export default regex;
